import type { HotelOption, HotelRoom } from '../../types';
import { createWhitelabelUrl } from './kayakWhitelabel';
import { createVioParams } from './vioWhitelabel';

type Props = {
    destinationContext?: HotelOption;
    startDate?: Date;
    endDate?: Date;
    rooms: HotelRoom[];
};

export const HotelHiddenInputs = ({ destinationContext, startDate, endDate, rooms }: Props) => {
    if (destinationContext?.objectId) {
        const values = createVioParams(destinationContext, startDate, endDate, rooms);
        return (
            <>
                <input type="hidden" name="label" value={values.label} />
                {values.placeId && <input type="hidden" name="placeId" value={values.placeId} data-testid="whiteLabelUrl" />}
                {values.hotelId && <input type="hidden" name="hotelId" value={values.hotelId} data-testid="whiteLabelUrl" />}
                <input type="hidden" name="checkIn" value={values.checkIn} />
                <input type="hidden" name="checkOut" value={values.checkOut} />
                <input type="hidden" name="rooms" value={values.rooms} />
                <input type="hidden" name="optimizeRooms" value={values.optimizeRooms} />
                <input type="hidden" name="userSearch" value={values.userSearch} />
                <input type="hidden" name="homeSearch" value={values.homeSearch} />
                <input type="hidden" name="userCountry" value={values.userCountry} />
            </>
        );
    }

    return (
        <input
            data-testid="whiteLabelUrl"
            type="hidden"
            name="url"
            value={createWhitelabelUrl(destinationContext, startDate, endDate, rooms)}
        />
    );
};
